// extracted by mini-css-extract-plugin
module.exports = {"Column":"SubTopicColumns_Column__2MDES"};